export default __webpack_public_path__ + "static/media/Asset 15.d35dac40.png";